import React from 'react'
import { Helmet } from 'react-helmet'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import { usePageView } from '../hooks/useAnalytics'
import './privacy-policy.css'

const MentionsLegales = () => {
  usePageView('Mentions Légales')

  return (
    <div className="privacy-policy-container">
      <Helmet>
        <title>Legal Notice / Mentions Légales - ORRAM Frames</title>
        <meta name="description" content="ORRAM Frames Legal Notice – Mentions Légales" />
      </Helmet>
      <Navigation />
      <main className="privacy-policy-main">
        <div className="privacy-policy-content">

          {/* ENGLISH */}
          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">Legal Notice</h1>
            <p className="privacy-policy-updated">ORRAM – Bespoke luxury frame maker</p>
          </div>

          <div className="privacy-section">
            <h2>1. Publisher</h2>
            <div className="company-info-box">
              <p><strong>ORRAM / Sasha de Saint Tropez</strong></p>
              <p>SIRET: 379 892 433</p>
              <p>Registered office: 10 place de l'Ormeau, 83990 Saint-Tropez, FRANCE</p>
              <p>Phone: <a href="tel:+33617596447">+33 6 17 59 64 47</a></p>
              <p>Email: <a href="mailto:orders@orram.shop">orders@orram.shop</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>2. Publication Director</h2>
            <p>Sasha de Saint Tropez</p>
          </div>

          <div className="privacy-section">
            <h2>3. Hosting</h2>
            <div className="company-info-box">
              <p><strong>Vercel Inc.</strong></p>
              <p>340 Pine Street, Suite 701, San Francisco, CA 94104, USA</p>
              <p><a href="https://vercel.com" target="_blank" rel="noopener noreferrer">vercel.com</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>4. Intellectual Property</h2>
            <p>All content on this website (texts, photographs, videos, graphics, logos) is the exclusive property of ORRAM and is protected by French and international intellectual property laws. Any reproduction, even partial, is strictly prohibited without prior written authorisation.</p>
          </div>

          <div className="privacy-section">
            <h2>5. Personal Data</h2>
            <p>For information on how your personal data is processed, please refer to our <a href="/privacy-policy">Privacy Policy</a>.</p>
          </div>

          <div className="privacy-section">
            <h2>6. Applicable Law</h2>
            <p>This website and its content are subject to French law. Any dispute shall fall under the exclusive jurisdiction of the French courts.</p>
          </div>

          {/* FRENCH */}
          <hr style={{ margin: '4rem 0', borderColor: '#e5e5e5' }} />

          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">Mentions Légales</h1>
            <p className="privacy-policy-updated">ORRAM – Créateur de cadres d'exception sur mesure</p>
          </div>

          <div className="privacy-section">
            <h2>1. Éditeur du site</h2>
            <div className="company-info-box">
              <p><strong>ORRAM / Sasha de Saint Tropez</strong></p>
              <p>SIRET : 379 892 433</p>
              <p>Siège social : 10 place de l'Ormeau, 83990 Saint-Tropez, FRANCE</p>
              <p>Téléphone : <a href="tel:+33617596447">+33 6 17 59 64 47</a></p>
              <p>Email : <a href="mailto:orders@orram.shop">orders@orram.shop</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>2. Directeur de la publication</h2>
            <p>Sasha de Saint Tropez</p>
          </div>

          <div className="privacy-section">
            <h2>3. Hébergement</h2>
            <div className="company-info-box">
              <p><strong>Vercel Inc.</strong></p>
              <p>340 Pine Street, Suite 701, San Francisco, CA 94104, États-Unis</p>
              <p><a href="https://vercel.com" target="_blank" rel="noopener noreferrer">vercel.com</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>4. Propriété intellectuelle</h2>
            <p>L'ensemble des contenus présents sur ce site (textes, photographies, vidéos, graphismes, logos) est la propriété exclusive d'ORRAM et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, même partielle, est strictement interdite sans autorisation écrite préalable.</p>
          </div>

          <div className="privacy-section">
            <h2>5. Données personnelles</h2>
            <p>Pour toute information relative au traitement de vos données personnelles, veuillez consulter notre <a href="/privacy-policy">Politique de Confidentialité</a>.</p>
          </div>

          <div className="privacy-section">
            <h2>6. Droit applicable</h2>
            <p>Le présent site et son contenu sont soumis au droit français. Tout litige relèvera de la compétence exclusive des tribunaux français.</p>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  )
}

export default MentionsLegales
